import { initAnimatedSVGElement } from './animated-svg';

import $ from 'jquery';
const SELECTOR = '[data-background-animation]';

function onDocumentReady() {
	$(SELECTOR).each(initializeElement);
}

function initializeElement(i, el) {
	const bgAnimation = $(`<div class="background-animation" data-animation="${el.getAttribute('data-background-animation')}"></div>`)
	$(el).prepend(bgAnimation);

	initAnimatedSVGElement(bgAnimation.get(0), true);
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
